import React, { useEffect, useState } from "react";
import ProfileManager from "../../components/profileManager";
import { getVdsProfile } from "../../services/user/UserServices";

const ProfileManagerPage = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const getProfile = async () => {
      const result = await getVdsProfile();
      if (result.success) setData(result.payLoad);
    };
    getProfile();
  }, []);
  return <ProfileManager data={data} />;
};

export default ProfileManagerPage;
